import { SubmissionStatus } from '../enums/submissionStatus'

export const statusLabels: Record<SubmissionStatus, string> = {
  [SubmissionStatus.Authentication]: 'vat_declarations.timeline.status.authentication',
  [SubmissionStatus.AuthenticationFailed]: 'vat_declarations.timeline.status.authentication_failed',
  [SubmissionStatus.Completed]: 'vat_declarations.timeline.status.completed',
  [SubmissionStatus.Delivery]: 'vat_declarations.timeline.status.delivery',
  [SubmissionStatus.DeliveryFailed]: 'vat_declarations.timeline.status.delivery_failed',
  [SubmissionStatus.UnknownError]: 'vat_declarations.timeline.status.unknown_error',
  [SubmissionStatus.Validation]: 'vat_declarations.timeline.status.validation',
  [SubmissionStatus.ValidationFailed]: 'vat_declarations.timeline.status.validation_failed',
}
